/* eslint-disable jsx-a11y/no-access-key */
import React from "react";
import style from "./style.module.sass";
import triangle from "./assets/triangle.svg"
import infoIcon from "../../../../../assets/information-circle.svg"
import { useTheme } from '@material-ui/core/styles';
import activeArrowLeft from "../../../../../assets/activeArrowLeft.svg";
import activeArrowLeftLight from "../../../../../assets/activeArrowLeftLight.svg"
import activeArrowLeftDark from "../../../../../assets/activeArrowLeftDark.svg"
import activeArrowRight from "../../../../../assets/activeArrowRight.svg";
import activeArrowRightLight from "../../../../../assets/activeArrowRightLight.svg"
import activeArrowRightDark from "../../../../../assets/activeArrowRightDark.svg"
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ComponentWithPop from "../../../../common/ComponentWithPop";
import { convertNumberToStringLocally, convertPipeToNewLine, stripHtml } from '../../../../../utils'
import { analyseSetTermCatTextTone } from '../../../../../actions'
import config from '../../../../../config'
import { SentimentDissatisfied, SentimentSatisfiedAlt, SentimentVeryDissatisfied, SentimentVerySatisfied } from "@material-ui/icons"

export default function AccordionModalDefault({
    handleOnPopupClick,
    getNextPopup,
    handleModalAccordionOpen,
    cells,
    title,
    enabledTypes,
    windowsKey
}) {
    const { theme: { bgColors, colors } } = useTheme();
    //const [openInfo, setOpenInfo] = useState(false);
    const {
        t,
        i18n: { language: i18nLanguage },
    } = useTranslation();
    const dispatch = useDispatch();
    const topAccordionOpen = useSelector(state => state.analyseData.topAccordionOpen);
    const modalAccordionOpen = useSelector(state => state.analyseData.modalAccordionOpen);
    const currentPopup = useSelector(state => state.analyseData.popover.currentPopup);
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)

    const prevPopUp = getNextPopup(-1, currentPopup, enabledTypes);
    const nextPopUp = getNextPopup(1, currentPopup, enabledTypes);

    const tabIndex = windowsKey === topAccordionOpen ? '0' : '-1'     
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const shouldShowLinguisticClimateInitials = isContrast && windowsKey === 'LinguisticClimate'
    const activeArrowLeftIcon = isContrast ? (themeState === config.THEMES_MODES.CONTRAST_DARK ? activeArrowLeftDark : activeArrowLeftLight) : activeArrowLeft
    const activeArrowRightIcon = isContrast ? (themeState === config.THEMES_MODES.CONTRAST_DARK ? activeArrowRightDark : activeArrowRightLight) : activeArrowRight

    const accordionClick = (c) => {
        dispatch(analyseSetTermCatTextTone(c.title))
        handleModalAccordionOpen(modalAccordionOpen === c.id ? "" : c.id)
    }
    return (
        <ul className={`${style.mainCont}`}>
            {cells.map(c => (
                <li key={c.id} style={{ backgroundColor: modalAccordionOpen === c.id ? bgColors.bgPrimary0 : "" }}
                    className={`${style.row} ${modalAccordionOpen === c.id && style.open} p-2 mt-1`}>
                    <div className={`d-flex align-items-start pb-1 ${style.head}`}>
                        {shouldShowLinguisticClimateInitials ? (
                            <span
                                className={`${style.initialBadge} mr-2`}
                                style={{ color: colors.colorIcons, borderColor: colors.colorIcons }}
                            >
                                {config.LINGUISTIC_CLIMATE_TITLE_INITIALS?.[c.title.toLowerCase()] || c.title[0].toUpperCase()}
                            </span>
                        ) : isContrast && (
                            (c.cellColor === "red") ? (
                                <SentimentVeryDissatisfied style={{ fill: colors.colorIcons }} />
                            ) : (c.cellColor === "yellow") ? (
                                <SentimentDissatisfied style={{ fill: colors.colorIcons }} />
                            ) : (c.cellColor === "green") ? (
                                <SentimentSatisfiedAlt style={{ fill: colors.colorIcons }} />
                            ) : (
                                <SentimentVerySatisfied style={{ fill: colors.colorIcons }} />
                            )
                        )}
                        <p className={`mr-2 mb-0 font-weight-bold`}
                            style={{ color: isContrast ? colors.colorText : c.colorTop, marginTop: "3px", marginLeft: "3px" }}>{c.num}{title === t('Linguistic climate') && "%"} </p>
                        
                        <p onClick={() => accordionClick(c)}
                            style={{
                                color: isContrast ? colors.colorText : modalAccordionOpen !== c.id ? colors.colorPrimary300 : colors.colorPrimary1000,
                                width: "200px"
                            }}
                            tabIndex={tabIndex}
                            data-accordion-item={topAccordionOpen === windowsKey ? "accordion" : ""}
                            data-compare-item={c.id}
                            className={`${style.title} m-0 ml-2`}>
                            {c.title}
                        </p>
                        <div
                            style={{ margin: "0 0 0 auto" }}
                            className="d-flex justify-content-end align-items-center"
                        >
                            {modalAccordionOpen === c.id && prevPopUp > -1 ? (
                                <button
                                    onClick={() => handleOnPopupClick(prevPopUp, c.title)}
                                    data-accordion-arrow={`up${c.id}`}
                                    aria-label={t('Previous Tip')}
                                    style={{ backgroundColor: "none", border: "none" }}
                                    className="p-0 m-0"
                                >
                                    <img className="mr-1" src={activeArrowLeftIcon} alt="" />
                                </button>
                            ) : (
                                <div style={{ width: "44px", height: "24px", marginRight: "4px" }} />
                            )}

                            {modalAccordionOpen === c.id && nextPopUp > -1 ? (
                                <button
                                    onClick={() => handleOnPopupClick(nextPopUp, c.title)}
                                    data-accordion-arrow={`down${c.id}`}
                                    aria-label={t('Next Tip')}
                                    style={{ backgroundColor: "none", border: "none" }}
                                    className="p-0 m-0"
                                >
                                    <img src={activeArrowRightIcon} alt="" />
                                </button>
                            ) : (
                                <div style={{ width: "44px", height: "24px" }} />
                            )}
                        </div>
                    </div>
                    <div className={`${style.modalWin} mt-1`}>
                        <div className={`${style.ranger} d-flex`} style={{ backgroundColor: bgColors.bgRadial}}>
                            <div style={{
                                width: `${c.scaleWidth === 0 ? 1 : c.scaleWidth}%`,
                                backgroundColor: isContrast ? bgColors.bgCockpitBar : c.colorBar
                            }} />
                            <img className={style.triangle} style={{ left: `calc(${c.targetTriangle}% - 12px)` }} src={triangle}
                                alt="" />
                        </div>
                        <div className={`d-flex align-items-center justify-content-between mt-2`}>
                            <p style={{ color: colors.colorPrimary500 }} className={`${style.desc} m-0`}>
                                {t("Proportion in text")}:  {t("Current")}
                                &nbsp;
                                {
                                    convertNumberToStringLocally(c.actual, i18nLanguage)
                                }
                                {c.absolute ? '' : '%'} | {t("Target")}
                                &nbsp;
                                {c.target}
                                {c.absolute ? '' : '%'}
                            </p>
                            <ComponentWithPop html={true} text={!!c.toolTip ? stripHtml(convertPipeToNewLine(c.toolTip, true), config.dangerousTags) : ""}>
                                <img style={{ cursor: "pointer" }} src={infoIcon} alt={!!c.toolTip ? c.toolTip : ""} />
                            </ComponentWithPop>
                        </div>
                    </div>
                </li>
            )
            )}
            {
                // <ModalWin open={openInfo} setOpen={setOpenInfo}/>
            }

        </ul>
    )
}
